import { gql } from '@apollo/client';

import { contentfulSysIdFragment } from '../../../../utils/contentful/contentfulQuery';

export const aiAgentQuery = gql`
  query AiAgentQuery($id: String!, $preview: Boolean!, $locale: String!) {
    aiAgent(id: $id, preview: $preview, locale: $locale) {
      ...ContentfulSysId
      welcomeMessage
      placeholderText
      suggestedPrompts
      disclaimer {
        json
      }
    }
  }
  ${contentfulSysIdFragment}
`;
